import * as React from "react";
import { Box, Stack, ListItem, Typography, Link } from "@mui/material";
import { HeaderNavProps } from "@/components/header/common/types";
import { injectSourceIntoUrl } from "@/config/unified-search-config";

type TertiaryNavItemProps = {
    item: HeaderNavProps;
};

export default function TertiaryNavItem(props: TertiaryNavItemProps) {
  const { item } = props;
  const navItemUrl = injectSourceIntoUrl(item.fields.url, "nav_item_url");
  return (
    <ListItem
      data-testid={`tertiary-nav-item-${item.fields.title}`}
      color="neutral"
      sx={{
        flexDirection: "column",
        alignItems: "initial",
        gap: 1,
        p: 0
      }}>
      <Stack direction="row" spacing={1.5}>
        <Box sx={{
            flex: 1
        }}>
          <Link
            href={navItemUrl ?? "#"}
            style={{
              textDecoration: "none",
              color: "inherit"
            }}
            className="navTertiary"
            data-nav-level="tertiary"
            data-nav-label={item.fields.title}
          >
            <Typography
              sx={{
                fontSize: "12px",
                fontWeight: "500",
                padding: 1
              }}
            >
              {item.fields.title}
            </Typography>
          </Link>
        </Box>
      </Stack>
    </ListItem>
  );
}
